module.exports = __webpack_public_path__ + "static/media/coliseu_box_4.4b65a362.jpg";